import StickyNav from '../components/StickyNav';
import QuickViewSpecModal from '../components/QuickViewSpecModal';
import HFSPanels from '../components/HFSPanels';
import ScheduleForm from '../components/ScheduleForm';
import HFSGridFilter from '../components/HFSGridFilter';
import { initMap } from '../components/CommunityMap';

document.addEventListener('DOMContentLoaded', () => {
    //sticky nav init
    StickyNav().init();

    //quick view init
    const quickviewModal = QuickViewSpecModal('js-quickview-modal');
    const quickviewBtns = document.querySelectorAll('.js-btn-quickview');
    quickviewBtns.forEach(quickviewBtn => {
        quickviewBtn.addEventListener('click', event => {
            event.preventDefault();
            const target = event.target as HTMLElement;
            const dataId = target.dataset.id;

            if (dataId) {
                // Now you have the data-id value, you can pass it to your function
                quickviewModal.open(Number(dataId));
            }
        });
    });
    //init panels
    HFSPanels('js-hfs-panels');
    new HFSGridFilter();
    //schedule form
    const scheduleForm = ScheduleForm();
    scheduleForm.init();
});

window.addEventListener('load', () => {
    //initialize map
    initMap('js-community-map-info-window').catch(error => {
        console.error('Failed to initialize map:', error);
    });
});
